import AjaxUtils from './ajaxUtils';

export const contactDataPointSearch = async searchData => AjaxUtils.post('/api/v2/search', searchData);
